module.exports = {
    extends: [
        '/',
        'base',
        'tabStrip',
        'slider',
        'tabStrip',
    ],

    methods: {
        onAfterFocus(registerSecret, registryEntry){
            const tab = (registryEntry || {}).tab || {}
            if(tab.$){
                tab.$[0].scrollIntoView()
            }
        },
    }
}